import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    item: {
        justifyContent: "center",
        flexDirection: "row"
    }
});
export default stylesheet;
